
import { WDFormInput } from './wd-form-input';

export class WDFormEmail extends WDFormInput {

  constructor(cfg)
  {
    cfg.type = 'email';
    super(cfg);
  };
  
  validate()
  {
		const data = this.value;

		if ( this.required == true && ( data.length == '0' || !this.isContentValid(data) ) )
		{
			console.log('Mark error empty');
			this.markError();
			return false;
		}
		else if (data.length > 0 && !this.isContentValid(data) )
		{
			console.log('Mark Error content');
			this.markError();
			return false;
		}
		else
		{
			console.log('Mark Success');
			this.markSuccess();
			return true;
		}
	};

	isContentValid(data)
	{
		return ( data.includes('@') && data.includes('.') );
	};
};

customElements.define('wd-form-email',WDFormEmail);

